module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart font-dark"
  }), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relatórios - Segmentados - Textuais")])]), _vm._v(" "), (!_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.renderReports()
      }
    }
  }, [_vm._v("Gerar")]), _vm._v(" "), _c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9 col-lg-9"
  }, [_c('div', {
    staticClass: "report-row"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll()
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected()
      }
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _vm._l((_vm.reports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.isSelected),
        expression: "report.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(report.isSelected) ? _vm._i(report.isSelected, null) > -1 : (report.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = report.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(report, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(report, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(report, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(report.title) + "\n              ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2"
  }, [_c('div', {
    staticClass: "report-row"
  }, [_c('p', [_c('strong', [_vm._v("Ano")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-inside-col"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getAvailableYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isRenderingReports = false
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center display-flex"
  }, _vm._l((_vm.selectedReports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "col-xs-12 col-lg-6"
    }, [_c(_vm.getReportComponent(report), {
      tag: "component",
      attrs: {
        "data": report.data
      }
    })], 1)
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2db28c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reports/SegmentedTextualReports.vue
// module id = 660
// module chunks = 1